define('vspot-angular/services/form-entries-service',[], function () {
    'use strict';

    return ['resources.FormEntries', function (FormEntries) {

        return {
            save: function(formKey, firstName, lastName, email, extraData, thankYouKey) {
                var data = {};
                if( extraData !== undefined ) {
                    data = extraData;
                }

                if( thankYouKey !== undefined ) {
                    data.thank_you_key = thankYouKey;
                }

                data.form_key   = formKey;
                data.first_name = firstName;
                data.last_name  = lastName;
                data.em_addr    = email;
                
                return FormEntries.save(data);
            }
        };
    }];
});

